import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { FormLabel } from '../../form-label';
import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { formatQuoteTimeWithZone } from 'utils/quote-time';

const QuoteTime = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel required={false}>{i18n.t(LOCALS.quote_date)}:</FormLabel>
      <Controller
        name={`productList.${index}.quoteTime`}
        control={control}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-1 flex-1 min-w-0">
            <DatePicker
              className="w-full"
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              placeholder={i18n.t(LOCALS.please_select) || ''}
              value={field.value ? dayjs(field.value) : null}
              status={fieldState.error ? 'error' : undefined}
              onChange={(value) =>
                field.onChange(value ? formatQuoteTimeWithZone(value) : null)
              }
            />
            {fieldState.error?.message && (
              <div className="text-xs text-red-500 leading-5">
                {fieldState.error.message}
              </div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default QuoteTime;
